import getUserLocale from 'get-user-locale'
// Import all translation files
import enTranslations from '../locales/en.json'
import csTranslations from '../locales/cs.json'
import skTranslations from '../locales/sk-SK.json'
import deTranslations from '../locales/de-AT.json'
import roTranslations from '../locales/ro-RO.json'

// Export getUserLocale for use in other components
export { getUserLocale }

// Type definition for translations
type TranslationKey = string
type TranslationObject = Record<string, any>

// Available translations
const translations: Record<string, TranslationObject> = {
  en: enTranslations,
  cs: csTranslations,
  'cs-CZ': csTranslations,
  sk: skTranslations,
  'sk-SK': skTranslations,
  de: deTranslations,
  'de-AT': deTranslations,
  ro: roTranslations,
  'ro-RO': roTranslations,
}

export function getTranslation(key: TranslationKey, variables?: Record<string, string>): string {
  const locale = getUserLocale()
  
  const translationObj = translations[locale] || translations['en']
  
  // Split the key by dots to navigate nested objects
  const keys = key.split('.')
  let value: any = translationObj
  
  // Navigate through the nested object
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k]
    } else {
      // Fallback to English if key not found in current locale
      if (locale !== 'en') {
        let fallbackValue: any = translations['en']
        for (const fallbackKey of keys) {
          if (fallbackValue && typeof fallbackValue === 'object' && fallbackKey in fallbackValue) {
            fallbackValue = fallbackValue[fallbackKey]
          } else {
            // Return the key itself if not found in fallback either
            return key
          }
        }
        value = fallbackValue
      } else {
        // Return the key itself if not found
        return key
      }
      break
    }
  }
  
  // If final value is not a string, return the key
  if (typeof value !== 'string') {
    return key
  }
  
  // Interpolate variables if provided
  if (variables) {
    return value.replace(/\{(\w+)\}/g, (match, varName) => {
      return variables[varName] || match
    })
  }
  
  return value
}
